module.exports = __webpack_public_path__ + "img/evse_icon_table.39d7e5fe.svg";